import { render, staticRenderFns } from "./Y03B.vue?vue&type=template&id=0800c209&scoped=true"
import script from "./Y03B.vue?vue&type=script&lang=js"
export * from "./Y03B.vue?vue&type=script&lang=js"
import style0 from "./Y03B.vue?vue&type=style&index=0&id=0800c209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0800c209",
  null
  
)

export default component.exports